import React, { useEffect, useState } from 'react';
import { Button, Modal, Header, Segment, Table, Message } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import { useStore } from '../../../../app/stores/store';
import { InvestmentInterest } from '../../../../app/models/Investment/InvestmentInterest';
import { formatCurrency } from '../../../../shared/utils';
import { InvestmentFundingMethod } from '../../../../app/models/Investment/InvestmentInterestGrid';

interface Props {
    show: boolean;
    closeModal: (refreshData: boolean) => void;
    interestId: number;
}

function PaymentReceivedModal({ show, closeModal, interestId }: Props) {
    const { investmentStore } = useStore();
    const [interest, setInterest] = useState(new InvestmentInterest());
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState('');

    useEffect(() => {
        investmentStore.getInvestmentInterestById(interestId)
            .then(r => {
                setTitle(interest.fundingMethod === InvestmentFundingMethod.wireTransfer ? 'Wire' : 'Check');
                setInterest(r);
            });
    }, [investmentStore, setInterest, interestId, interest.fundingMethod]);

    const confirmWire = () => {
        setLoading(true);
        investmentStore.updateInvestmentInterestStatusReceived(interestId)
            .then(r => {
                toast.success("Funding info updated successfully.", { theme: "colored" });
                closeModal(true);
            })
            .catch(err => {
                toast.error("There was an issue updating the funding.", { theme: "colored" });
            })
            .finally(() => setLoading(false));
    }
    return (
        <Modal size="tiny" centered={false} open={show} closeOnEscape={false} closeOnDimmerClick={false}>
            <Modal.Header>
                <Header color='blue'>{title} Transfer Information</Header>
            </Modal.Header>
            <Modal.Content>
                <Segment basic>
                    You are about to mark this {title.toLowerCase()} transfer payment as received.<br />
                    Please confirm the details below before proceeding.
                </Segment>

                <Segment basic>
                    <Header as="h3" color='blue'>Payment Details</Header>
                    <Table compact className="no-lines">
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell width={5}><b>Name:</b></Table.Cell>
                                <Table.Cell>{interest.entityName}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell><b>Shares:</b></Table.Cell>
                                <Table.Cell>{interest.shareCount}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell><b>Amount:</b></Table.Cell>
                                <Table.Cell>{formatCurrency(interest.amount)}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell><b>Invoice Number:</b></Table.Cell>
                                <Table.Cell>{interest.id}</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Segment>

                <Message info
                    icon='exclamation circle'
                    content='Once confirmed, this status cannot be undone unless manually adjusted. Ensure the payment has been verified in your bank records.' />

            </Modal.Content>
            <Modal.Actions style={{ display: 'flex', justifyContent: 'center' }}>
                <Button primary content="Confirm Payment" onClick={confirmWire} loading={loading} disabled={loading} />
                <Button content="Cancel" onClick={() => closeModal(false)} />
            </Modal.Actions>
        </Modal>
    );
}

export default PaymentReceivedModal;
